module.exports = __webpack_public_path__ + "static/media/proxy-established-no.03556ebd.svg";